import type { components } from '@/types/api-schema';

export type PeriodType = components['schemas']['PeriodType'];

/**
 * 期間タイプ（年月/年月日/年月日時分/期間）
 *
 * `satisfies` の型に mapped type を使うことで、SSOT（OpenAPI 生成型）に新しい
 * PeriodType 値が追加された際に、このオブジェクトの項目不足がコンパイルエラーとして
 * 検出される。キー名は値の uppercase と一致させる必要がある。
 */
export const PERIOD_TYPE = {
  YEAR_MONTH: 'year_month',
  DATE: 'date',
  DATETIME: 'datetime',
  DATE_RANGE: 'date_range',
  DATETIME_RANGE: 'datetime_range',
} as const satisfies { [K in PeriodType as Uppercase<K>]: K };
